export default __webpack_public_path__ + "static/media/html.31497a13.png";